import { Environment } from '@util/Environment';
import 'firebase/compat/remote-config';
import { App } from 'hydra-data-types';
import { MarkViewedOn } from './Experiment';
import { RemoteConfigExperiment } from './RemoteConfigExperiment';

namespace Variant {
  export const Dev = {
    A: 'VariantA',
    B: 'VariantB',
  } as const;

  export const PaymentRedesign = {
    Control: 'Control',
    Program: 'Program',
    Sales: 'Sales',
  } as const;
}

/**
 * Configure the active experiments. This should be done in conjunction with configuring the related experiments in
 * Firebase RemoteConfig. See the Dev experiment for an example of naming conventions etc.
 *
 * This Notion page has more detailed information:
 * https://www.notion.so/mindsethealth/Setting-up-Split-Test-Experiments-0102de5390c04668bee6d4111ee86516
 */
export const AllExperiments = {
  Dev: new RemoteConfigExperiment({
    name: 'DevExperiment',
    variants: Variant.Dev,
    default: Variant.Dev.A,
    activeApps: [App.Nerva],
    markViewedOn: Environment.DEVELOPMENT ? MarkViewedOn.Init : MarkViewedOn.None,
  }),

  /**
   * Payment page: current layout vs the person's program and plan from their answers (Program) vs
   * offer-led with proof (Sales). Mirrors the hydra-mobile `PaywallRedesign` experiment.
   */
  PaymentRedesign: new RemoteConfigExperiment({
    name: 'PaymentRedesign',
    variants: Variant.PaymentRedesign,
    default: Variant.PaymentRedesign.Control,
    activeApps: [App.Nerva],
    markViewedOn: MarkViewedOn.React,
  }),
} as const;

export const ActiveExperimentList = Object.values(AllExperiments).filter(
  (experiment) => experiment.isActive
);
